import { SelectFilter } from "@/app/components/FilterBar/SelectFilter"
import type { ClientTheme } from "@/app/lib/themes"

interface Props {
  trOptions: string[]
  selectedTR: string
  invLoading: boolean
  onChange: (value: string) => void
  theme: ClientTheme
}

export function TownshipSelector({ trOptions, selectedTR, invLoading, onChange, theme }: Props) {
  return (
    <div className="flex items-center gap-3 mb-7">
      <span
        style={{
          fontFamily: "var(--font-ui)",
          fontSize: "13px",
          color: theme.textMuted,
          flexShrink: 0,
        }}
      >
        Township-Range
      </span>
      {invLoading ? (
        <div
          style={{
            width: "220px",
            height: "34px",
            borderRadius: "8px",
            backgroundColor: theme.bgSurface2,
            border: `1px solid ${theme.borderColor}`,
          }}
        />
      ) : (
        <SelectFilter
          value={selectedTR}
          onChange={onChange}
          placeholder="Select Township-Range…"
          options={trOptions}
          width="220px"
          theme={theme}
        />
      )}
    </div>
  )
}
